module.exports = "form{\n    margin-left: 40%;\n}\nh2{\n    margin-left: 40%;\n    font-family: \"Times New Roman\", Times, serif;\n    font-style: oblique;\n     font-weight: bold;\n}\nlabel{\n     font-family: \"Times New Roman\", Times, serif;\n    font-style: oblique;\n     font-weight: bold;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/suscribe/suscribe.component.css
// module id = ./src/app/components/suscribe/suscribe.component.css
// module chunks = main